module.exports = __webpack_public_path__ + "static/media/family_night.4ca2e49c.jpg";